var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-avatar"},[_c('el-avatar',{attrs:{"fit":"fill","size":_vm.size,"src":_vm.url}}),(_vm.isVip)?_c('div',{staticClass:"level",style:(_vm._vipSize)}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }